import styled from 'styled-components';
import Button from '@carvana/forms/Button';

export default styled(Button)`
  border-radius: 0px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 35px;
  max-width: 100%;
  width: 350px;
`;
